import { EyeOutlined, RedoOutlined, FilePdfOutlined, FileExcelOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import { Col, Row, Tooltip } from 'antd';
import { Text } from 'atoms';
import { getCSV, getPDF } from 'store/vendorBillSlice';
import { getCapsTitle } from 'utils/helpers';
import { ACL } from 'components/common';

export const VendorInvoiceListTableConfig = (showRegenerateButton = true) => [
	{
		title: 'Bill No',
		dataIndex: 'vendor_bill_no',
		key: 'vendor_bill_no',
		hidden: false,
		render: (vendor_bill_no) => <Text overFlow="hidden">{vendor_bill_no || ''}</Text>,
	},
	{
		title: 'Billing Period ',
		dataIndex: 'bill_period',
		key: 'bill_period',
		hidden: false,
		render: (bill_period) => <Text overFlow="hidden">{bill_period || ''}</Text>,
	},
	{
		title: 'Revision',
		dataIndex: 'version',
		key: 'version',
		hidden: false,
		render: (version) => <Text overFlow="hidden">{version || ''}</Text>,
	},
	{
		title: 'Vendor Name',
		dataIndex: 'vendor_name',
		key: 'vendor_name',
		hidden: false,
		render: (vendor_name) => <Text overFlow="hidden">{getCapsTitle(vendor_name) || ''}</Text>,
	},
	{
		title: 'No of Trips',
		dataIndex: 'no_of_trips',
		key: 'no_of_trips',
		hidden: false,
		render: (no_of_trips) => <Text overFlow="hidden">{no_of_trips || ''}</Text>,
	},
	{
		title: 'Invoice Amount',
		dataIndex: 'bill_amount',
		key: 'bill_amount',
		hidden: false,
		render: (bill_amount) => (
			<Text overFlow="hidden">
				{' '}
				₹{' '}
				{bill_amount !== null && bill_amount !== undefined
					? bill_amount.toLocaleString('en-IN', {
							minimumFractionDigits: 2,
							maximumFractionDigits: 2,
					  })
					: ''}{' '}
			</Text>
		),
	},
	{
		title: 'Paid Amount',
		dataIndex: 'paid_amount',
		key: 'paid_amount',
		hidden: false,
		render: (paid_amount) => (
			<Text overFlow="hidden">
				{' '}
				₹{' '}
				{paid_amount !== null && paid_amount !== undefined
					? paid_amount.toLocaleString('en-IN', {
							minimumFractionDigits: 2,
							maximumFractionDigits: 2,
					  })
					: '0'}{' '}
			</Text>
		),
	},
	{
		title: 'Tds Amount',
		dataIndex: 'tds_amount',
		key: 'tds_amount',
		hidden: false,
		render: (tds_amount) => (
			<Text overFlow="hidden">
				{' '}
				₹{' '}
				{tds_amount !== null && tds_amount !== undefined
					? tds_amount.toLocaleString('en-IN', {
							minimumFractionDigits: 2,
							maximumFractionDigits: 2,
					  })
					: ''}{' '}
			</Text>
		),
	},
	{
		title: 'Toll Amount',
		dataIndex: 'toll_amount',
		key: 'toll_amount',
		hidden: false,
		render: (toll_amount) => (
			<Text overFlow="hidden">
				{' '}
				₹{' '}
				{toll_amount !== null && toll_amount !== undefined
					? toll_amount.toLocaleString('en-IN', {
							minimumFractionDigits: 2,
							maximumFractionDigits: 2,
					  })
					: ''}{' '}
			</Text>
		),
	},
	{
		title: 'Deduction',
		dataIndex: 'deduction_amount',
		key: 'deduction_amount',
		hidden: false,
		render: (deduction_amount) => (
			<Text overFlow="hidden">
				{' '}
				₹{' '}
				{deduction_amount !== null && deduction_amount !== undefined
					? deduction_amount.toLocaleString('en-IN', {
							minimumFractionDigits: 2,
							maximumFractionDigits: 2,
					  })
					: ''}{' '}
			</Text>
		),
	},
	{
		title: 'Total Payable',
		dataIndex: 'total_payable_amount',
		key: 'total_payable_amount',
		hidden: false,
		render: (total_payable_amount) => (
			<Text overFlow="hidden">
				{' '}
				₹{' '}
				{total_payable_amount !== null && total_payable_amount !== undefined
					? total_payable_amount.toLocaleString('en-IN', {
							minimumFractionDigits: 2,
							maximumFractionDigits: 2,
					  })
					: ''}{' '}
			</Text>
		),
	},
	{
		title: 'Payment Status',
		dataIndex: 'invoice_status',
		key: 'invoice_status',
		hidden: false,
		render: (invoice_status) => <Text overFlow="hidden">{invoice_status || ''}</Text>,
	},
	{
		title: 'Pending Payment Percentage',
		dataIndex: 'pending_amount_percentage',
		key: 'pending_amount_percentage',
		hidden: false,
		render: (pending_amount_percentage) => (
			<Text overFlow="hidden">
				{pending_amount_percentage !== null && pending_amount_percentage !== undefined
					? `${pending_amount_percentage.toFixed(2)}%`
					: '0.00%'}
			</Text>
		),
	},
	{
		title: 'Action',
		dataIndex: 'id',
		key: 'id',
		hidden: false,
		render: (id) => (
			<Row gutter={8} justify="space-between">
				<Col>
					<Link to={`/vendor-bill-invoice/${id}`}>
						<Tooltip title="View Invoice">
							<EyeOutlined />
						</Tooltip>
					</Link>
				</Col>
				{/* <Col>
					<Link to={`/vendor-bill-edting/${id}`}>
						<Tooltip title="Edit Invoice">
							<EditOutlined />
						</Tooltip>
					</Link>
				</Col> */}
				{showRegenerateButton && (
					<Col>
						<ACL action="update" module="vendor_bill_regenerate">
							<Link to={`/vendor-bill-regeneration/${id}`}>
								<Tooltip title="Regenerate Invoice">
									<RedoOutlined
										style={{
											color: '#9d43b3',
											fontSize: '14px',
										}}
									/>
								</Tooltip>
							</Link>
						</ACL>
					</Col>
				)}
				<Col>
					<Tooltip title="Download Invoice">
						<FilePdfOutlined
							style={{
								color: 'red',
								fontSize: '14px',
							}}
							onClick={getPDF({ id })}
						/>
					</Tooltip>
				</Col>

				<Col>
					<Tooltip title="Export Invoice">
						<FileExcelOutlined
							style={{
								color: 'green',
								fontSize: '14px',
							}}
							onClick={getCSV({ id })}
						/>
					</Tooltip>
				</Col>

				{/* <Link to={`/vendor-invoice-pdf/${id}`}>
					<FilePdfOutlined />
				</Link> */}
			</Row>
		),
	},
];
